import Service from './service'
export var ApiOperatorMessageType;
(function (ApiOperatorMessageType) {
  ApiOperatorMessageType["OPERATOR_CALL_RESPONSE"] = "operator.call.response"
  ApiOperatorMessageType["OPERATOR_CONTROL_STATUS"] = "operator.control.status"
  ApiOperatorMessageType["OPERATOR_CALL_REQUEST"] = "operator.call.request"
})(ApiOperatorMessageType || (ApiOperatorMessageType = {}))
export var OperatorMessageType;
(function (OperatorMessageType) {
  OperatorMessageType["OPERATOR_CALL_START"] = "OPERATOR_CALL_START"
  OperatorMessageType["OPERATOR_CALL_RESPONSE"] = "OPERATOR_CALL_RESPONSE"
  OperatorMessageType["OPERATOR_CONTROL_STATUS"] = "OPERATOR_CONTROL_STATUS"
})(OperatorMessageType || (OperatorMessageType = {}))
/**
 * Сервис для работы с телеприсутствием
 * @version 0.0.1
 * @since 1.9.0
 */
export default class OperatorService extends Service {
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiOperatorMessageType.OPERATOR_CALL_RESPONSE:
          if (typeof typeof message.response !== 'undefined') {
            this.broadcast(OperatorMessageType.OPERATOR_CALL_RESPONSE, message.response)
          }
          break
        case ApiOperatorMessageType.OPERATOR_CONTROL_STATUS:
          if (typeof typeof message.status !== 'undefined') {
            this.broadcast(OperatorMessageType.OPERATOR_CONTROL_STATUS, message.status)
          }
          break
      }
    }
    this.messageChannel.subscribe(ApiOperatorMessageType.OPERATOR_CALL_RESPONSE, messageHandler)
    this.messageChannel.subscribe(ApiOperatorMessageType.OPERATOR_CONTROL_STATUS, messageHandler)
  }
  /**
     * Вызов оператора начат
     *
     * @since 1.9.0
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof OperatorService
     *
     * @example <caption>Вызов оператора начат</caption>
     * robot.operatorService.onCallStart(() => {
     *   ...
     * })
     */
  onCallStart(callback) {
    return this.subscribe(OperatorMessageType.OPERATOR_CALL_START, callback)
  }
  /**
     * Сервис сообщил ответ оператора
     *
     * @since 1.9.0
     * @param {(response: string) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof OperatorService
     *
     * @example <caption>Сервис сообщил ответ оператора</caption>
     * robot.operatorService.onOperatorCallResponse((response) => {
     *   ...
     * })
     */
  onOperatorCallResponse(callback) {
    return this.subscribe(OperatorMessageType.OPERATOR_CALL_RESPONSE, callback)
  }
  /**
     * Сервис сообщил управляется ли робот оператором удаленно
     *
     * @since 1.9.0
     * @param {(status: boolean) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof OperatorService
     *
     * @example <caption>Сервис сообщил управляется ли робот оператором удаленно</caption>
     * robot.operatorService.onOperatorControlStatus((status) => {
     *   ...
     * })
     */
  onOperatorControlStatus(callback) {
    return this.subscribe(OperatorMessageType.OPERATOR_CONTROL_STATUS, callback)
  }
  /**
     * Вызвать оператора телеприсутсвия
     *
     * @since 1.9.0
     * @param {boolean} status - Начать или отменить вызов
     * @memberof OperatorService
     *
     * @example <caption>Вызвать оператора телеприсутсвия</caption>
     * robot.operatorService.operatorCall(status)
     */
  operatorCall(status) {
    if (status === true) {
      this.broadcast(OperatorMessageType.OPERATOR_CALL_START)
    }
    this.messageChannel.send({
      type: ApiOperatorMessageType.OPERATOR_CALL_REQUEST,
      call: status,
    })
  }
}
